// https://docs.google.com/spreadsheets/d/12Gn8lADnTSk8I968IWHBc3Scrq8-zpbiZSar1Hpd64s/edit#gid=896546730

const LOCATION = 'login - quiz';
const VIRTUAL_PAGEVIEW_URL_QUIZ_SELECTION_MODAL = '/quiz';
const VIRTUAL_PAGEVIEW_URL_QUIZ_QUESTION_MODAL = '/quiz-question';
const VIRTUAL_PAGEVIEW_URL_QUIZ_RESULTS_MODAL = '/quiz-results-card';
const DASHBOARD_MODULE = 'quiz';

// #2
export function dashboardPromotionalsChooseQuizCtaClickEvent (track) {
  const trackingData = {
    event: 'login_dashboard_quiz',
    location: 'login - dashboard page',
    intent: 'Choose Product Quiz click',
    dashboardModule: DASHBOARD_MODULE,
  };

  track({ data: trackingData });
}

// #5
export function quizSelectionModalLoadEvent (track) {
  const trackingData = {
    event: 'virtualPage',
    location: LOCATION,
    virtualPageURL: VIRTUAL_PAGEVIEW_URL_QUIZ_SELECTION_MODAL,
  };

  track({ data: trackingData });
}

// #6
export function quizSelectionModalCloseEvent (track, quizName) {
  const trackingData = {
    event: 'login_dashboard_quiz',
    location: LOCATION,
    intent: 'Quiz card close',
    title: quizName,
    dashboardModule: DASHBOARD_MODULE,
    virtualPageURL: VIRTUAL_PAGEVIEW_URL_QUIZ_SELECTION_MODAL,
  };

  track({ data: trackingData });
}

// #7
export function quizSelectionModalNavigationEvent (track, quizName, slideIndex) {
  const trackingData = {
    event: 'login_dashboard_quiz',
    location: LOCATION,
    intent: 'Quiz selection',
    position: slideIndex + 1,
    title: quizName,
    dashboardModule: DASHBOARD_MODULE,
    virtualPageURL: VIRTUAL_PAGEVIEW_URL_QUIZ_SELECTION_MODAL,
  };

  track({ data: trackingData });
}

// #8
export function quizSelectionModalStartQuizEvent (track, quizName, slideIndex) {
  const trackingData = {
    event: 'login_dashboard_quiz',
    location: LOCATION,
    intent: 'Take Product Quiz click',
    position: slideIndex + 1,
    title: quizName,
    dashboardModule: DASHBOARD_MODULE,
    virtualPageURL: VIRTUAL_PAGEVIEW_URL_QUIZ_SELECTION_MODAL,
  };

  track({ data: trackingData });
}

// #9
export function quizSelectionModalPastResultsEvent (track, quizName) {
  const trackingData = {
    event: 'login_dashboard_quiz',
    location: LOCATION,
    intent: 'Past results',
    title: quizName,
    dashboardModule: DASHBOARD_MODULE,
    virtualPageURL: VIRTUAL_PAGEVIEW_URL_QUIZ_SELECTION_MODAL,
  };

  track({ data: trackingData });
}

// #10
export function quizSelectionModalRetakeQuizEvent (track, quizName) {
  const trackingData = {
    event: 'login_dashboard_quiz',
    location: LOCATION,
    intent: 'Take quiz again',
    title: quizName,
    dashboardModule: DASHBOARD_MODULE,
    virtualPageURL: VIRTUAL_PAGEVIEW_URL_QUIZ_SELECTION_MODAL,
  };

  track({ data: trackingData });
}

// #11
export function quizQuestionModalLoadEvent (track) {
  const trackingData = {
    event: 'virtualPage',
    location: LOCATION,
    virtualPageURL: VIRTUAL_PAGEVIEW_URL_QUIZ_QUESTION_MODAL,
  };

  track({ data: trackingData });
}

// #12
export function quizQuestionModalCloseEvent (track, quizName, questionIndex) {
  const trackingData = {
    event: 'login_dashboard_quiz',
    location: LOCATION,
    intent: `Question ${questionIndex + 1} close`,
    title: quizName,
    dashboardModule: DASHBOARD_MODULE,
    virtualPageURL: VIRTUAL_PAGEVIEW_URL_QUIZ_QUESTION_MODAL,
  };

  track({ data: trackingData });
}

// #13
export function quizResultsModalLoadEvent (track) {
  const trackingData = {
    event: 'virtualPage',
    location: LOCATION,
    virtualPageURL: VIRTUAL_PAGEVIEW_URL_QUIZ_RESULTS_MODAL,
  };

  track({ data: trackingData });
}

// #14
export function quizResultsModalCloseEvent (track, quizName) {
  const trackingData = {
    event: 'login_dashboard_quiz',
    location: LOCATION,
    intent: 'Results card close',
    title: quizName,
    dashboardModule: DASHBOARD_MODULE,
    virtualPageURL: VIRTUAL_PAGEVIEW_URL_QUIZ_RESULTS_MODAL,
  };

  track({ data: trackingData });
}

// #15
export function quizResultsModalRecommendedProductCtaEvent (track, quizName) {
  const trackingData = {
    event: 'login_dashboard_quiz',
    location: LOCATION,
    intent: 'See your recommended cards click',
    title: quizName,
    dashboardModule: DASHBOARD_MODULE,
    virtualPageURL: VIRTUAL_PAGEVIEW_URL_QUIZ_RESULTS_MODAL,
  };

  track({ data: trackingData });
}

// #16
export function quizResultsModalTakeQuizAgainCtaEvent (track, quizName) {
  const trackingData = {
    event: 'login_dashboard_quiz',
    location: LOCATION,
    intent: 'Take quiz again',
    title: quizName,
    dashboardModule: DASHBOARD_MODULE,
    virtualPageURL: VIRTUAL_PAGEVIEW_URL_QUIZ_RESULTS_MODAL,
  };

  track({ data: trackingData });
}

export default {
  quizSelectionModalLoadEvent,
  quizSelectionModalCloseEvent,
  quizSelectionModalNavigationEvent,
  quizSelectionModalStartQuizEvent,
  quizSelectionModalPastResultsEvent,
  quizSelectionModalRetakeQuizEvent,
  quizQuestionModalLoadEvent,
};
